import * as React from "react";
import { cn } from "@/lib/utils";
import "./data-panel.css";

function DataPanel({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="data-panel"
      className={cn("data-panel", className)}
      {...props}
    />
  );
}

function DataPanelTitle({ className, ...props }: React.ComponentProps<"h3">) {
  return (
    <h3
      data-slot="data-panel-title"
      className={cn("data-panel-title", className)}
      {...props}
    />
  );
}

function DataPanelDescription({
  className,
  ...props
}: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="data-panel-description"
      className={cn("data-panel-description", className)}
      {...props}
    />
  );
}

export { DataPanel, DataPanelTitle, DataPanelDescription };
